// ============================================================
// HOOKED ENGINE — CDN                       [Tier 1 harvest]
// One file. One domain. One truth.
// Every image in every zone pulls from here.
// To move assets to a new domain: change one line.
// NOTE: hooked-assets project not created yet — placeholder
// domain. All sprites glyph-fallback gracefully until real art
// lands (Sprite.js onError law).
// ============================================================

export const CDN = "https://hooked-assets.pages.dev";

// ── Asset URL helpers ─────────────────────────────────────────
export const cdnUrl  = (filename) => `${CDN}/${filename}`;
export const fishUrl = (fishId)   => `${CDN}/fish_${fishId}.webp`;
